import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import Button, { ButtonVariant } from "./Button";
const ModalConfirmation = ({ message, children, buttonConfirm, buttonConfirmContents, buttonReject, buttonRejectContents, wide = false, }) => {
    const savedHandler = useRef(null);
    useEffect(() => {
        savedHandler.current = window.addEventListener('keydown', (ev) => {
            if (ev.key === 'Escape') {
                buttonReject();
            }
        });
        // Cleanup
        return () => {
            window.removeEventListener('keydown', savedHandler.current);
        };
    }, []);
    // Responsive modal width classes
    // For wide: full width on mobile, 2xl on md, 4xl on lg+
    // For not wide: full width on mobile, md on md+
    const modalWidthClasses = wide
        ? "w-full max-w-full sm:max-w-2xl lg:max-w-4xl"
        : "w-full max-w-full sm:max-w-md";
    return (_jsx("div", { className: "fixed top-0 left-0 w-screen h-screen z-10 bg-white bg-opacity-75 flex justify-center place-items-center text-base", children: _jsxs("div", { className: `m-8 p-8 border-salmon-600 border-2 bg-white bg-opacity-100 ${modalWidthClasses}`, children: [_jsx("span", { className: "font-heavy text-xl", children: message }), children, buttonConfirmContents && (_jsx(Button, { onClick: buttonConfirm, className: "mt-8", variant: ButtonVariant.Salmon, children: buttonConfirmContents })), buttonRejectContents && (_jsx(Button, { onClick: buttonReject, className: "mt-8", variant: ButtonVariant.Outlined, children: buttonRejectContents }))] }) }));
};
export default ModalConfirmation;
